module.exports = __webpack_public_path__ + "static/media/Envelope-gray.22c933fa.svg";